// Privates local storage
const localStorageGetObject = key => JSON.parse(localStorage.getItem(key));
const localStorageSetItem = (key, value) => localStorage.setItem(key, JSON.stringify(value));
const localStorageRemoveItem = key => localStorage.removeItem(key);
// Local Storage
export const lsGetOfferGuid = () => localStorageGetObject('offer:guid');
export const lsSetOfferGuid = value => localStorageSetItem('offer:guid', value);
export const lsRemoveOfferGuid = () => {
  localStorageRemoveItem('offer:guid');
};
export const lsGetOnboardingGuid = () => localStorageGetObject('onboarding:guid');
export const lsSetOnboardingGuid = value => localStorageSetItem('onboarding:guid', value);
export const lsRemoveOnboardingGuid = () => {
  localStorageRemoveItem('onboarding:guid');
};

export const lsGetOnboarding = () => localStorageGetObject('onboarding:onboarding');
export const lsSetOnboarding = value => localStorageSetItem('onboarding:onboarding', value);
export const lsRemoveOnboarding = () => {
  localStorageRemoveItem('onboarding:onboarding');
};
